import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { replaceAllAttributes } from '../attributesSlice'
import { Attribute } from '../models/Attribute'

export const fetchAttributes = createAsyncThunk('attributes/fetchAttributes', async (_, { dispatch }) => {
  const attributes = await OLMSApiService.get<Attribute[]>('/list/Attributes')

  if (attributes) {
    dispatch(replaceAllAttributes(attributes))
  }

  return attributes
})